interface RequestType {
  value?: string;
  description?: string;
  more_info?: string;
}

export function buildDescription(
  requestTypeFields: string[],
  requestTypes?: RequestType[]
) {
  return requestTypeFields
    .map((requestTypeField) =>
      getRequestTypeDescription(requestTypeField, requestTypes)
    )
    .join(", ");
}

function getRequestTypeDescription(
  requestTypeField: string,
  requestTypes?: RequestType[]
) {
  return requestTypes?.find(({ value }) => value === requestTypeField)
    ?.description;
}
